// extracted by mini-css-extract-plugin
export default {"aboutWrapper":"About_aboutWrapper__+Y5On","aboutWrapper__info":"About_aboutWrapper__info__nJQwx","aboutWrapper__image":"About_aboutWrapper__image__GxSEq","up":"About_up__fKZOS"};